<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="绑定产品-确认绑定"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="750px"
        append-to-body>
        <div class="content-wrap p20">
            <p class="text-color-error text-bold mb20">以下产品已经绑定客户，且为启用状态，需要停用原来客户的绑定关系吗?</p>
            <el-table
                ref="dataTable"
                :data="dataList"
                tooltip-effect="dark"
                :header-cell-style="{background:'#e8eaec',color:'#333'}"
                :max-height="350"
                stripe
                style="width: 100%;">
                <el-table-column
                    prop="subproject_name"
                    label="推广名称"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="subproject_id"
                    label="推广ID"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="subproject_content"
                    label="推广内容"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="plat_name"
                    label="归属媒体"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="company_name"
                    label="绑定客户"
                    align="center"
                    min-width="100">
                </el-table-column>
            </el-table>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="danger" @click="confirmResult('2')" class="action-btn mr20">停用</el-button>
            <el-popover
                placement="top"
                width="160"
                v-model="popoverVisible">
                <p>您确认不停用原来客户的绑定关系吗?</p>
                <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="popoverVisible = false">取消</el-button>
                    <el-button type="primary" size="mini" @click="confirmResult('1')">确认</el-button>
                </div>
                <el-button type="default" slot="reference" class="action-btn ml20">不停用</el-button>
            </el-popover>

        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "AppResultModal",
        props:{
            dataList:Array,
        },
        data(){
            return {
                dialogVisible:false,
                popoverVisible:false,
            }
        },
        methods:{
            confirmResult(val){
                this.$emit('confirm',val);
                this.dialogVisible = false;
                this.popoverVisible = false;
            },
            showModal(){
                this.dialogVisible = true;
            }
        }
    }
</script>

<style scoped>

</style>
